import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, useMediaQuery } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { REPs } from "../../config";
import { ACPlans, ACRows, ChartDataTypes, CompareGridContextProps, PlanProps } from "../../types";
import { ChartFooter } from "../styles/common.styled";
import {
  ACGrid,
  ACGridContentWrapper,
  ACGridItem,
} from "../styles/compare.styled";
import {useContext} from "react";
import { CompareGridContext } from "../../context-manager";
import { pushToDataLayer } from "../data";

// This is a Grid for AC Protection marketing campaign.
const LplGrid = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const mobileSize = useMediaQuery("(max-width:430px)");

  const { products, acPlans, gridData, acRows,} = useContext(CompareGridContext) as CompareGridContextProps
  
  const pushDataLayer = (product:any) =>{
    const {plan_name, plan_id, contract_term} = product;
    pushToDataLayer({
      event: "sign_up_start",
      electricity_plan_name: plan_name,
      electricity_rate_plan_id: plan_id,
      plan_term: contract_term,
      page_path: location.pathname,
      campaign_source:''
    });
  }

  return (
    <ACGrid container spacing={0} columns={3 * (gridData.length + 1)}>
      <ACGridItem item xs={3}></ACGridItem>
      {acPlans?.map((plan) => {
        const index = gridData.findIndex(
          (rep: any) => rep.id === plan.provider_id
        );
        if (index !== -1) {
          return (
            <ACGridItem
              item
              xs={3}
              className={plan.provider_id !== "196" ? "col-header" : ""}
            >
              <ACGridContentWrapper
                className={
                  plan.provider_id !== "196"
                    ? "col-header-wrapper"
                    : "rep-header"
                }
              >
                <img
                  src={plan.imageSrc}
                  width="100px"
                  height="50px"
                  alt="direct-energy"
                />
                <p>{plan.plan_name}</p>
              </ACGridContentWrapper>
            </ACGridItem>
          );
        }
        return null;
      })}
      <ACGridItem className="row-header" item xs={3}>
        <ACGridContentWrapper>
          <strong>Fixed Electric Supply Rate</strong>
          <span className="sub-title">Based on 1000 kWh</span>
        </ACGridContentWrapper>
      </ACGridItem>
      {acPlans.map((plan) => {
        return (
          <>
            {gridData.find((rep: any) => rep.id === plan.provider_id) && (
              <ACGridItem className="rep-column" item xs={3}>
                <ACGridContentWrapper>
                  <strong className="price">
                    {gridData
                      .find((rep: any) => rep.id === plan.provider_id)
                      ?.value.toFixed(1)}
                    ¢
                  </strong>
                  <span className="sub-title">per kwh</span>
                </ACGridContentWrapper>
              </ACGridItem>
            )}
          </>
        );
      })}

      {acRows.map((row, ind) => {
        return (
          <>
            <ACGridItem
              className="row-header"
              item
              xs={3}
              style={
                ind === acRows.length - 1
                  ? { borderBottom: "1px solid rgba(0, 0, 0, 0.12)" }
                  : {}
              }
            >
              <ACGridContentWrapper>
                <strong>{row.rowHeader}</strong>
              </ACGridContentWrapper>
            </ACGridItem>
            {acPlans?.map(
              ({ provider_id, ...acPlan }: any, index: number) =>
                gridData.find((rep: any) => rep.id === provider_id) && (
                  <ACGridItem
                    key={provider_id}
                    className={index === 1 || index === 0 ? "rep-column" : ""}
                    item
                    xs={3}
                    style={
                      ind === acRows.length - 1
                        ? { borderBottom: "1px solid rgba(0, 0, 0, 0.12)" }
                        : {}
                    }
                  >
                    <ACGridContentWrapper>
                      <p
                        className={
                          row.rowHeader === "Plan Term" ? "plan-term" : ""
                        }
                      >
                        {" "}
                        {typeof acPlan[row.rowAttribute] === "boolean" ? (
                          acPlan[row.rowAttribute] ? (
                            <FontAwesomeIcon
                              size="3x"
                              icon="check-circle"
                              color="green"
                            />
                          ) : (
                            <FontAwesomeIcon icon="times" />
                          )
                        ) : (
                          acPlan[row.rowAttribute]
                        )}
                      </p>
                    </ACGridContentWrapper>
                  </ACGridItem>
                )
            )}
          </>
        );
      })}

      <ACGridItem style={{ border: "none" }} item xs={3}></ACGridItem>
      {acPlans?.map((plan) => {
        if (plan.provider_id === REPs[0].providerId)
          return (
            <>
              <ACGridItem className="sign-up-btn" item xs={3}>
                <div style={{ marginTop: 20 }}>
                  <Button
                    size={mobileSize ? "small" : "large"}
                    variant="secondary"
                    onClick={() => {
                      let product;
                      if (plan.plan_name === "Renewable Plan*") {
                        product = products.find((product) =>
                          product.plan_name.includes("Usage Bill Credit")
                        );
                      } else {
                        product = products.find((product) =>
                          product.plan_name.includes(plan.plan_name)
                        );
                      }
                      localStorage.setItem(
                        "selectProduct",
                        JSON.stringify(product)
                      );
                      pushDataLayer(product)
                      navigate(`/v2/enrollment/step1${location.search}`);
                    }}
                  >
                    Sign Up
                  </Button>
                </div>
              </ACGridItem>
            </>
          );
      })}
      <ChartFooter>
        The comparisons above are to companies that we believe meet our standard
        of quality, and do not represent all plans available from us or from our
        competitors listed. Plans are subject to change based on market
        conditions and provider offerings.
      </ChartFooter>
    </ACGrid>
  );
};

export default LplGrid;
